export default "__VITE_ASSET__DN7b1iyl__"